import { ModemFinalDE, ModemFinalKind } from "@visonum/network-quality-sdk";

export const getRouterSpeed = (modem: ModemFinalDE): number | null => {
    return modem.modemFinal.kind === ModemFinalKind.ModemFinalAvailable ? modem.modemFinal.speed : null;
}